import { loadOrganizationRedirects } from '../services/organizations';

export const handleOrganizationRedirect = async (
  missedOrganization: string,
  ctx: App.ReduxNextPageContext<Record<any, any>>,
) => {
  if (ctx.res) {
    const redirects = await loadOrganizationRedirects();
    if (redirects[missedOrganization]) {
      const redirectUrl = ctx.req.url.replace(missedOrganization, redirects[missedOrganization]);
      ctx.res.writeHead(301, { Location: redirectUrl });
      ctx.res.end();

      return true;
    }

    return false;
  }
};
